// SimpleIcons.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex, Tooltip } from 'antd';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const SimpleIcons = ({
  items = [],
  align = 'start',
  className = '',
  gap = '0',
  hover = false,
  iconSize = '16px',
  color = '',
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Flex justify={align} align="center" gap={gap} className={className}>
      {items.map((item, idx) => {
        const key = item.key || idx;

        const iconWrapper = (
          <div
            key={key}
            onClick={item.onClick}
            style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              border: hover ? '1px solid #d9d9d9' : 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: item.onClick && hover ? 'pointer' : 'default',
              transition: 'all 0.2s ease-in-out',
              backgroundColor: hover ? '#fff' : 'unset',
            }}
            className={hover ? 'hover-shadow' : ''}
          >
            <span className={!color && 'text-primary'} style={{ fontSize: iconSize, color }}>
              {item.icon}
            </span>
          </div>
        );

        return item.tooltipText ? (
          <Tooltip
            key={`tooltip-${key}`}
            title={item.tooltipText}
            placement={item.tooltipPlacement || 'top'}
          >
            {iconWrapper}
          </Tooltip>
        ) : (
          iconWrapper
        );
      })}
    </Flex>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleIcons;
